import React, { useState, useReducer, useCallback, useEffect, useContext } from 'react';
import styled/*, { css }*/ from 'styled-components';
import { Container, Buttons, HeaderContainer, LineUIContainer, NoImage, BackButton, ValidationAlert, LineUiImageWrapper } from '../../style';
import { SmallInput, LineReducer, LineSetContext, LineUI, PageHeader, Button } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';
import { MenuContext, PathContext } from '../../App';
import useLocalStorage from '../../hooks/useLocalstorage';
import noImg from '../../images/noimg.png';
import { SNAPSHOT_API_URL } from '../../utils/Constants';


const InputContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  justify-content: space-between;
  height: 102px;
`;

const AreaInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;
const SelectFieldBox = styled.select`
  width: 104px;
  height: 30px;
  padding: 0 0 0 10px;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  color: #767676;
  margin-top: 5px;
`;

const Position = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;

const SmallInputContainer = styled.div`
  display: flex;
  width: auto;
  margin: 0 30px 0 0; 
`;

const SmallInputBox = styled(SmallInput)`
  width: 104px;
  padding: 0 14px 0 0;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 12px;
  color: #767676;
  margin-top: -5px;
`;

const InputHeader = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #7f7f7f;
  margin-bottom: 7px;
`;

const InputField = styled.div`
  display: flex;
  flex-direction: column;
`;


const LineUIWrapper = styled(LineUIContainer)`
  margin-bottom: 30px;
`;

const LineUIImageContainer = styled(LineUiImageWrapper)`
  margin-left: -30px;
  padding: 20px 30px;
`;


const PlaceCameras = () => {
  const [imgsrc, setImgsrc] = useState(SNAPSHOT_API_URL + '?p=' + new Date().getTime());
  
  const { t } = useTranslation(['PlaceCameras', 'Common']);
  const [validationAlert, setValidationAlert] = useState<{ key?: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });

  const { completedStep, setSelectedStep, setCompletedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage, setFloorPlanStorage } = useLocalStorage();

  const [state, dispatch] = useReducer(LineReducer, []);
  const [selectedAreaName, setSelectedAreaName] = useState('');
  const [bodyAreas, setBodyAreas] = useState(floorPlanStorage.BodyAreas ? floorPlanStorage.BodyAreas : []);

  const [ maxBodyAreaID, setMaxBodyAreaID ] = useState(floorPlanStorage.maxBodyAreaID ? floorPlanStorage.maxBodyAreaID : 0);

  useEffect(() => {
    setInterval(() => {
      setImgsrc(SNAPSHOT_API_URL + '?p=' + new Date().getTime());
    }, 3000);
  }, []);



  /*--------エリア設定--------*/
  //エリア初期化
  useEffect(() => {    
    if ( floorPlanStorage.BodyAreas.length !== 0 ){
      setSelectedAreaName(floorPlanStorage.BodyAreas[0].data.name);
      const data = [];
      for (const i in floorPlanStorage.BodyAreas){
        data.push(floorPlanStorage.BodyAreas[i].data);
      }
      dispatch({
        type: 'LOAD',
        state: data
      });
    }else{
      setSelectedAreaName('BodyArea0');
      const data = {
        name: 'BodyArea0',
        points: [
          {'x': 0, 'y': 0},
          {'x': 300, 'y': 0},
          {'x': 300, 'y': 200},
          {'x': 0, 'y': 200}
        ]
      };
      dispatch({
        type: 'ADD_SET',
        data 
      });
      setBodyAreas([{'id': 0, 'data': data}]);
    }
  }, [floorPlanStorage.BodyAreas, setBodyAreas, setCompletedStep]);

  //エリア追加
  const addArea = useCallback( () => {
    const newid = maxBodyAreaID+1;
    let newname = 'BodyArea' + newid;

    const nameList = [];
    for(let i = 0; i < bodyAreas.length; i++) {//既存name取得
      nameList.push(bodyAreas[i].data.name);
    }
    if (nameList.indexOf(newname) !== -1){
      newname = '_BodyArea' + newid;
    }

    const data = {
      name: newname,
      points: [
        {'x': 0, 'y': 0},
        {'x': 300, 'y': 0},
        {'x': 300, 'y': 200},
        {'x': 0, 'y': 200}
      ]
    };
    dispatch({
      type: 'ADD_SET',
      data
    });

    setBodyAreas([...bodyAreas, {'id': newid, 'data': data}]);
    setSelectedAreaName(newname);
    setMaxBodyAreaID(maxBodyAreaID+1);
    setCompletedStep(12);
  }, [maxBodyAreaID, bodyAreas, setCompletedStep]);

  //エリア削除
  const removeArea = useCallback( () => {    
    if (state.length <= 1) return false;
    // id削除
    for(const i in bodyAreas){
      if(bodyAreas[i].data.name === selectedAreaName) {
        bodyAreas.splice(Number(i), 1);
      }
    }

    for(const i in state){
      if(state[i].name === selectedAreaName) {
        const index = Number(i);
        dispatch({
          type: 'REMOVE_SET',
          index
        });
        if(index === 0) setSelectedAreaName((state[1].name));
        else setSelectedAreaName((state[0].name));
        break;
      }
    }
    setCompletedStep(12);
  }, [state, bodyAreas, selectedAreaName, setCompletedStep]);

  //エリア名変更
  const renameArea = useCallback(({ target: { value } }) => {
    const newBodyAreas = [...bodyAreas];
    const newState = [...state];

    //同名判定
    for(const i in newBodyAreas){
      if(bodyAreas[i].data.name === value) {
        setValidationAlert({ key: new Date(), message: '同名のエリアが存在しております。エリア名：'+value, type: 'error' });
        return;
      }
    }

    for(const i in newBodyAreas){
      if(bodyAreas[i].data.name === selectedAreaName) {
        newBodyAreas[i].data.name = value;
        break;
      }
    }
    for(const i in newState){
      if(newState[i].name === selectedAreaName) {
        newState[i].name = value;
        break;
      }
    }

    dispatch({
      type: 'LOAD',
      state: newState
    });
    setBodyAreas(newBodyAreas);
    setSelectedAreaName(value);
    setCompletedStep(12);
  }, [state, bodyAreas, selectedAreaName, setCompletedStep]);

  const addPoint = useCallback(() => {
    for(const i in state){
      if(state[i].name === selectedAreaName) {
        const index = Number(i);
        dispatch({
          type: 'ADD_POINT',
          index
        });
        break;
      }
    }
    setCompletedStep(12);
  },[state, selectedAreaName, setCompletedStep]);

  const removePoint = useCallback(() => {
    for(const i in state){
      if(state[i].name === selectedAreaName) {
        if(state[i].points.length <= 3) return;
        const index = Number(i);
        dispatch({
          type: 'REMOVE_POINT',
          index
        });
        break;
      }
    }
    setCompletedStep(12);
  },[state, selectedAreaName, setCompletedStep]);

  /*--------エリア設定--------*/

  const getSelectedArea : React.ChangeEventHandler<HTMLSelectElement> = (ev) => {
    for(const i in state){
      if(state[i].name === ev.target.value) {
        setSelectedAreaName(ev.target.value);
        break;
      }
    }
  };

  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    // 最新のLineReducer stateを記録
    const newBodyAreas = [];
    for(let i = 0; i < bodyAreas.length; i++) {
      for(let k = 0; k < state.length; k++) {
        if (bodyAreas[i].data.name === state[k].name){
          newBodyAreas.push({'id': bodyAreas[i].id, 'data': state[k]});
        }
      }
    }

    setSelectedStep(index);
    setFloorPlanStorage({BodyAreas: newBodyAreas});
    setFloorPlanStorage({maxBodyAreaID});
    setCompletedStep(completedStep > 12 ? completedStep : 12);
  }, [maxBodyAreaID, state, bodyAreas, completedStep, setCompletedStep, setSelectedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(12); }
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='身体部位判定エリア設定' areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <BackButton size='small' design='secondary' onClick={() => onContinue(11)}>{t('Common:back')}</BackButton>
          <Button design='primary' size='small' onClick={() => onContinue(13)}>{t('Common:next')}</Button>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}

      {imgsrc ?
        <>
          <InputContainer>
            <AreaInfo>
              <InputHeader>部位エリア追加</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <Button design='primary' size='small' onClick={addArea}>add</Button>
                </InputField>
              </SmallInputContainer>
            </AreaInfo>

            <AreaInfo>
              <InputHeader>エリア詳細</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <SelectFieldBox value={selectedAreaName} onChange={getSelectedArea}>
                    {state.map((item: any)=>{
                      return <option key={item.name} value={item.name}>{item.name}</option>;
                    })}
                  </SelectFieldBox>
                </InputField>
              </SmallInputContainer>
            </AreaInfo>

            <Position>
              <InputHeader>エリア名</InputHeader>
              <SmallInputContainer>                
                <InputField>
                  <SmallInputBox label='' value={selectedAreaName} onChange={renameArea} />
                </InputField>
              </SmallInputContainer>
            </Position>

            <Position>
              <InputHeader>頂点数設定</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <Button size='small' design='primary' onClick={removePoint}>－</Button>
                </InputField>
                <InputField>
                  <Button size='small' design='primary' onClick={addPoint}>＋</Button>
                </InputField>
              </SmallInputContainer>
            </Position>
            
            <AreaInfo>
              <InputHeader>エリア削除</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <Button size='small' design='primary' onClick={removeArea}>remove</Button>
                </InputField>
              </SmallInputContainer>
            </AreaInfo>
            

          </InputContainer>

          <LineUIImageContainer height={window.innerHeight - 340} id='camera-position-img' isScrollbar={false}>
            <LineSetContext.Provider value={{ state, dispatch }}>
              <LineUIWrapper className='shadow'>
                <LineUI src={imgsrc} />
              </LineUIWrapper>
            </LineSetContext.Provider>
          </LineUIImageContainer>
        </> :
        <NoImage src={noImg} />}
    </Container>
  );
};

export default PlaceCameras;
